/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for keyConstraintType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="keyConstraintType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="unique"/&gt; &lt;enumeration value="repeating"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class KeyConstraintType extends Enum{

	enumValue = null;

	static  UNIQUE = KeyConstraintType.newLiteral("unique");

	static  REPEATING = KeyConstraintType.newLiteral("repeating");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < KeyConstraintType.values().length); ++i) {
			if (KeyConstraintType.values()[i].enumValue == v) {
				return KeyConstraintType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("KeyConstraintType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/KeyConstraintType.js